import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { BinaryDecisionViewModel, ComponentType, PromptComponent } from '@k12/models';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule],

  selector: 'lib-pc-binary-decision',
  styleUrl: './pc-binary-decision.component.scss',
  templateUrl: './pc-binary-decision.component.html'
})
export class PcBinaryDecisionComponent implements OnInit {
  @Input() allowPointerEvents!: boolean;
  @Input() configJson: PromptComponent = {
    componentType: ComponentType.BinaryDecision,
    header: undefined,
    inputType: 'binary_decision',
    instructions: undefined,
    label: '',
    order: 0,
    inputs: [
      {
        inputType: 'radio',
        instructions: '',
        order: 0,
        label: '',
        dataType: 'text',
        isRequired: true,
        options: [
          {
            order: 0,
            label: 'Yes',
            value: 'yes',
            subLabel: '',
            dataType: 'text'
          },
          {
            order: 1,
            label: 'No',
            value: 'no',
            subLabel: '',
            dataType: 'text'
          }
        ]
      }
    ]
  };
  @Input() isYesNo: WritableSignal<boolean> = signal(false);

  @Output() cbConfig = new EventEmitter();
  @Output() decisionEvent = new EventEmitter();

  public selectedDecision!: boolean | number;
  public vm!: BinaryDecisionViewModel;

  public ngOnInit(): void {
    this.vm = {
      noIcon: 'fa fa-circle-xmark',
      noLabel: 'No',
      yesIcon: 'fa fa-circle-check',
      yesLabel: 'Yes'
    };
    this.cbConfig.emit(this.configJson);
    this.isYesNo.set(this.configJson.componentType === ComponentType.YesNoDecision);

    if (this.configJson.inputs[0].value && this.configJson.inputs[0].value !== null) {
      this.selectedDecision = this.configJson.inputs[0].value === 'true' ? 0 : 1;
    }
  }

  public decisionButtonClick(event: boolean | number): void {
    // TODO (future): Convert string to boolean when BE is ready
    let emitValue: boolean | string | number = event;
    this.selectedDecision = emitValue;

    if (typeof event === 'number') {
      emitValue = event === 0 ? 'true' : 'false';
      this.selectedDecision = event;
    }

    this.decisionEvent.emit({
      formName: this.configJson.id ?? '',
      control: { [this.configJson.inputs[0].id ?? '']: emitValue.toString() }
    });
  }
}
